import React from 'react';
import {useIsMaxSm} from 'features/auth/ui/AuthorizationSteps/useIsMaxSm';
import {Drawer} from 'shared/ui/Drawer';
import {SBP_INFO_PARAGRAPHS, SBP_INFO_TITLE} from '../../model/sbpPhone';
import styles from './SbpInfoDrawer.module.css';

export type SbpInfoDrawerProps = {
	open: boolean;
	onClose: () => void;
};

export function SbpInfoDrawer({open, onClose}: SbpInfoDrawerProps): React.ReactElement {
	const isMaxSm = useIsMaxSm();

	return (
		<Drawer
			open={open}
			onClose={onClose}
			title={SBP_INFO_TITLE}
			showCloseButton
			closeButtonPosition="end"
			variant={isMaxSm ? 'fullscreen' : 'side'}
			bodyClassName={styles.drawerBody}
		>
			<div className={styles.content}>
				{SBP_INFO_PARAGRAPHS.map((paragraph) => (
					<p key={paragraph} className={styles.paragraph}>
						{paragraph}
					</p>
				))}
			</div>
		</Drawer>
	);
}
